/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Generate_Aria_LabelInputs */

const en_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate activation code`)
};

const fr_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer le code d'activation`)
};

const de_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivierungscode generieren`)
};

const it_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera codice di attivazione`)
};

const ru_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сгенерировать код активации`)
};

const es_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar código de activación`)
};

const zh_cn2_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成激活码`)
};

const ja_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーションコードを生成する`)
};

const hi_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्टिवेशन कोड जनरेट करें`)
};

const pt_pt2_offline_activation_generate_aria_label = /** @type {(inputs: Offline_Activation_Generate_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar código de ativação`)
};

/**
* | output |
* | --- |
* | "Generate activation code" |
*
* @param {Offline_Activation_Generate_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_generate_aria_label = /** @type {((inputs?: Offline_Activation_Generate_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Generate_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_generate_aria_label(inputs)
	if (locale === "de") return de_offline_activation_generate_aria_label(inputs)
	if (locale === "it") return it_offline_activation_generate_aria_label(inputs)
	if (locale === "ru") return ru_offline_activation_generate_aria_label(inputs)
	if (locale === "es") return es_offline_activation_generate_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_generate_aria_label(inputs)
	if (locale === "ja") return ja_offline_activation_generate_aria_label(inputs)
	if (locale === "hi") return hi_offline_activation_generate_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_generate_aria_label(inputs)
	return en_offline_activation_generate_aria_label(inputs)
});